import React from 'react';
import { useSelector } from 'react-redux';
import {
  WalletContainer,
  WalletConfigContextProvider,
  SavedPaymentMethodsContainer,
  AddPaymentMethodContainer,
} from '@product-marketing/payment';

import PortalContainer from '@components/PortalContainer';
import Container from '@common/components/Container/Container';

export const Wallet = () => {
  const { userProfile } = useSelector(state => state);
  const { customerId } = userProfile.user;

  return (
    <PortalContainer>
      <Container style={{ paddingBottom: '30px' }}>
        <WalletContainer lucidId={customerId} />
      </Container>
      <Container style={{ paddingBottom: '30px', display: 'none' }}>
        <WalletConfigContextProvider>
          <SavedPaymentMethodsContainer lucidId={customerId} />
          <AddPaymentMethodContainer />
        </WalletConfigContextProvider>
      </Container>
    </PortalContainer>
  );
};
